module.exports = __webpack_public_path__ + "img/6.6ffd6091.svg";